import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useAuthStore } from '@/lib/store';
import { AppShell } from '@/components/AppShell';
import { ProtectedRoute } from '@/components/ProtectedRoute';

import SplashPage from '@/pages/Splash';
import LoginPage from '@/pages/Login';
import AuthCallbackPage from '@/pages/AuthCallback';
import DashboardPage from '@/pages/Dashboard';
import EventsListPage from '@/pages/EventsList';
import EventWizardPage from '@/pages/EventWizard';
import EventDetailPage from '@/pages/EventDetail';
import MemoriesPage from '@/pages/Memories';
import ProfilePage from '@/pages/Profile';
import NotificationsPage from '@/pages/Notifications';
import AdminPage from '@/pages/Admin';
import SharePage from '@/pages/Share';

function App() {
  const init = useAuthStore((s) => s.init);
  useEffect(() => { init(); }, [init]);

  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
      <Routes>
        <Route path="/splash" element={<SplashPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/share/:token" element={<SharePage />} />

        <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/events" element={<EventsListPage />} />
          <Route path="/events/new" element={<EventWizardPage />} />
          <Route path="/events/:id" element={<EventDetailPage />} />
          <Route path="/memories" element={<MemoriesPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
